import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScalarResponseModel } from "../../models/scalar/scalar.model";

@Injectable({
    providedIn: 'root'
})
export class CustomersTicketsCountService {

    private CUSTOMERSTICKETSCOUNT_URL = 'api/SupportTicketsCount/2' //  0 for All, 1 for Distrubtors, 2 for Customers

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.CUSTOMERSTICKETSCOUNT_URL;
    }

    getCustomersTicketsCount$(): Observable<ScalarResponseModel> {
        return this._httpClient.get<ScalarResponseModel>(this.CUSTOMERSTICKETSCOUNT_URL);
    }
}
